// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import RequestStatus, { processRequestStatus } from "./RequestStatus";
import SocialThemeImageTile from "./SocialThemeImageTile";
import SocialThemeType from "enums/SocialThemeType";
import Util from "PreciateUtil";

export default interface SocialTheme {
    socialThemeId?: string;
    type?: SocialThemeType;
    socialThemeName?: string;
    description?: string;
    colorPrimary?: string;
    colorSecondary?: string;
    colorBackground?: string;
    colorGradientBackground?: string;
    colorButtonText?: string;
    colorButtonBG?: string;
    imageFarURI?: string;
    imageMidURI?: string;
    imageNearURI?: string;
    previewImageURI?: string;
    minimapImageURI?: string;
    imageWidth?: number;
    imageHeight?: number;
    templateId?: string;
    defaultArtifactSetId?: string;
    dateCreated?: Date;
    multiSize?: boolean;
    addToMiniMap?: boolean;
    tiles?: SocialThemeImageTile[];
    uploadStatus?: RequestStatus;
}

export function processSocialTheme(value?: SocialTheme): void {
  if (value) {
    value.dateCreated = Util.toDate((value as any).dateCreated);
    processRequestStatus(value.uploadStatus);
  }
}

export function processSocialThemeArray(array?: SocialTheme[]): void {
  if (array) {
    for (const v of array) {
      processSocialTheme(v);
    }
  }
}
